import { useContext } from 'react';

import { ExternalShareContext } from '@confluence/external-share-context/entry-points/ExternalShareContext.ts';
import { expValEquals } from '@confluence/feature-experiments';

/**
 * Whether the current request should be treated as a restricted external share.
 *
 * `isExternalShareRequest` is true for both public share links and access links. Access link
 * viewers resolve to real principals, so once `cc_perms_ga_access_links` is enabled their view
 * page features are driven by their own permissions rather than by the route they arrived on.
 * Public (anonymous) share link viewers remain restricted in all cases.
 */
export const useIsRestrictedExternalShareRequest = (): boolean => {
	const { isExternalShareRequest, isAccessLinkRequest } = useContext(ExternalShareContext);

	// The experiment is evaluated inline, experiment-last per lint rules, so it is only reached
	// for access link viewers.
	return (
		isExternalShareRequest &&
		!(isAccessLinkRequest && expValEquals('cc_perms_ga_access_links', 'isEnabled', true))
	);
};
